import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { isMobile, thousandSeparator } from "utils"
import { LazyImage, Tooltip } from "components"
import classes from "./FoodCard.module.scss"

const FoodCard = props => {
  const { food, setOpenModal, setSelectedFood } = props

  const [t] = useTranslation()

  const handleClick = () => {
    if (disabled) return

    setOpenModal(true)

    setSelectedFood(food)
  }

  const getPriceRange = () => {
    const prices = food.options.map(o => o.salePrice)

    const min = Math.min(...prices)

    const max = Math.max(...prices)

    if (min === max) return `${thousandSeparator(min)}`

    return `${thousandSeparator(min)} ~ ${thousandSeparator(max)}`
  }

  const isSoldout =
    food.options.every(option =>
      option.outOfStock ||
      (
        option.stockManagement &&
        option.availableQuantity <= 0
      )
    )

  const disabled =
    isSoldout

  return (
    <div className={classes["container"]}>
      <div
        onClick={handleClick}
        className={clsx(classes["wrapper"],
          disabled && classes["disable"]
        )}
      >
        <div className={classes["image-wrapper"]}>
          <LazyImage
            src={food.imageCover}
            imageWidth={300}
            quality={80}
            className={classes["image"]}
          />
        </div>
        <div className={classes["details"]}>
          <div className={classes["code"]}>
            {t("کد")}: {food.code}
          </div>
          <div className={classes["name"]}>
            <Tooltip
              title={!isMobile() ? food.name : ""}
            >
              <span>
                {food.name}
              </span>
            </Tooltip>
          </div>
          <div className={classes["footer"]}>
            {isSoldout
              ?
              <div className={classes["soldout"]}>
                {t("ناموجود")}
              </div>
              :
              <div className={classes["price"]}>
                {getPriceRange()}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(FoodCard)